export default __webpack_public_path__ + "static/media/mailchimp-logo.c651a6c0.png";